import { usePlayer } from "../player/playerContext";
import { QueryResult, useQuery, useQueryCache } from "react-query";
import fetchApi from "../backend/fetchApi";
import { Syndicate } from "../models/syndicate";

const useSyndicates = () => {
  const [player] = usePlayer() as any;
  const queryCache = useQueryCache();

  const syndicatesUrl = player?._links?.syndicates?.href + "?shallow=true";

  const syndicates = useQuery<Syndicate[], unknown>(
    ["syndicates", syndicatesUrl],
    () =>
      fetchApi(syndicatesUrl!).then((response) => response.json())
        .then((r) => r._embedded.syndicates),
    {
      enabled: !!player,
    }
  );

  return [
    syndicates.data,
    {
      ...syndicates,
      reloadSyndicates: () => queryCache.invalidateQueries("syndicates"),
    },
  ] as [
    Syndicate[] | undefined,
    QueryResult<Syndicate[]> & {
      reloadSyndicates: () => Promise<any>;
    }
  ];
};

export default useSyndicates;
